export default __webpack_public_path__ + "static/media/USD+.7949c729.png";